export const MAX_MOBILE_VIEW = 767;
export const MAX_TABLET_VIEW = 1189;

export const isDesktop = (width: number) => {
  return width > MAX_TABLET_VIEW;
};
